import { Expose } from 'class-transformer';

export class MandatoryProblemReportingConfigResponseDto {
    /**
     * Mandatory problem reporting configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Assessment Organization Name
     * @example 'Jazz Pharmaceuticals'
     */
    @Expose()
    assessmentOrganization?: string;

    /**
     * Assessment Email
     * @example 'assessment@client.com'
     */
    @Expose()
    assessmentEmail?: string;

    /**
     * Reporting to HC Organization Name
     * @example 'Q&C'
     */
    @Expose()
    reportingToHCOrganization?: string;

    /**
     * Reporting to HC Email
     * @example 'hc.reports@qccompany.com'
     */
    @Expose()
    reportingToHCEmail?: string;

    /**
     * Notes
     * @example 'Follow FDA MDR requirements and ISO 14971 risk management'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;
}
